import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import Select from "react-select";
import axios from 'axios';
import DatePicker, { DateObject } from "react-multi-date-picker";
import "react-multi-date-picker/styles/colors/green.css";
import { Table, Button } from "react-bootstrap";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const Manage_Target = () => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const userId = localStorage.getItem('user_id'); // <-- fetch user_id from localStorage
  const [loading, setLoading] = useState(false);
  const [branchOptions, setBranchOptions] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [monthFilValue, setMonthFilValue] = useState(new DateObject().set({ day: 1 }));
  const [targetAmount, setTargetAmount] = useState("");
  const [preCustomers, setPreCustomers] = useState("");
  const [postCustomers, setPostCustomers] = useState("");
  const [targetsList, setTargetsList] = useState([]);
  const [showValidation, setShowValidation] = useState(false);

  // Fetch Branches
  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const response = await axios.get(`${baseURL}/dropdown/branch`);
        if (response.data?.data) {
          const formatted = response.data.data.map((b) => ({
            value: b.sno,
            label: `${b.branch_name} (${b.branch_code})`,
          }));
          setBranchOptions(formatted);
        }
      } catch (error) {
        console.error("Error fetching branches:", error);
      }
    };
    fetchBranches();
  }, [baseURL]);

  // Fetch all targets for the selected month
  useEffect(() => {
    const fetchAllTargets = async () => {
      setLoading(true);
      try {
        const monthParam = monthFilValue.format("YYYY-MM");
        const response = await axios.get(`${baseURL}/kpi-target?month=${monthParam}`);
        if (response.data?.data) {
          setTargetsList(
            response.data.data.map((t, index) => ({
              id: index + 1,
              branchId: t.branch_id,
              branch: branchOptions.find((b) => b.value === t.branch_id)?.label || "",
              month: monthFilValue.format("MMM-YYYY"),
              targetAmount: t.target_amount,
              preCustomers: t.pre_customers,
              postCustomers: t.post_customers,
            }))
          );
        } else {
          setTargetsList([]);
        }
      } catch (error) {
        console.error("Error fetching targets:", error);
      }
      setLoading(false);
    };

    fetchAllTargets();
  }, [monthFilValue, baseURL, branchOptions]);

  // Fetch target for selected branch
  useEffect(() => {
    if (!selectedBranch) return;

    const fetchBranchTarget = async () => {
      setLoading(true);
      try {
        const monthParam = monthFilValue.format("YYYY-MM");
        const response = await axios.get(`${baseURL}/kpi-target?branch_id=${selectedBranch}&month=${monthParam}`);
        if (response.data?.data && response.data.data.length > 0) {
          const t = response.data.data[0];
          setTargetAmount(t.target_amount);
          setPreCustomers(t.pre_customers);
          setPostCustomers(t.post_customers);
          setTargetsList([
            {
              id: 1,
              branchId: selectedBranch,
              branch: branchOptions.find((b) => b.value === selectedBranch)?.label || "",
              month: monthFilValue.format("MMM-YYYY"),
              targetAmount: t.target_amount,
              preCustomers: t.pre_customers,
              postCustomers: t.post_customers,
            },
          ]);
        } else {
          setTargetAmount("");
          setPreCustomers("");
          setPostCustomers("");
          setTargetsList([]);
        }
      } catch (error) {
        console.error("Error fetching branch target:", error);
        
      }
      setLoading(false);
    };

    fetchBranchTarget();
  }, [selectedBranch, monthFilValue, baseURL, branchOptions]);

  // Handle branch selection
  const handleBranchChange = (selectedOption) => {
    setSelectedBranch(selectedOption ? selectedOption.value : null);
  };

  // Handle Add/Update target
  const handleAddTarget = async () => {
    if (!selectedBranch || !monthFilValue || !targetAmount) {
      setShowValidation(true);
      return;
    }

    try {
      const payload = {
        branch_id: selectedBranch,
        month: monthFilValue.format("YYYY-MM"),
        target_amount: targetAmount,
        pre_customers: preCustomers || 0,
        post_customers: postCustomers || 0,
        created_by: userId, // <-- use userId from localStorage
        updated_by: userId, // <-- use userId from localStorage
      };

      const response = await axios.post(`${baseURL}/kpi-target`, payload);

      // Update UI
      const t = response.data.data;
      setTargetsList([
        {
          id: 1,
          branchId: t.branch_id,
          branch: branchOptions.find((b) => b.value === t.branch_id)?.label || "",
          month: monthFilValue.format("MMM-YYYY"),
          targetAmount: t.target_amount,
          preCustomers: t.pre_customers,
          postCustomers: t.post_customers,
        },
      ]);

      setShowValidation(false);
      toast.success("Target Fixed for Branch!", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
    } catch (error) {
      console.error("Error adding/updating target:", error);
        toast.error("Failed to save. Try again!", { position: "top-center" });
    }
  };

  const handleClear = () => {
    setSelectedBranch(null);
    setMonthFilValue(new DateObject().set({ day: 1 }));
    setTargetAmount("");
    setPreCustomers("");
    setPostCustomers("");
    setTargetsList([]);
    setShowValidation(false);
  };

  return (
    <>
      {/* Header */}
      <div className="d-flex align-items-center justify-content-between page-titles flex-wrap px-0 py-1 mx-0">
        <div className="mb-2">
          
            {loading ? (
              <>
                <div className="mb-0 px-0">
                    <h4 className="text-primary fw-bold"><Skeleton width={150} /> </h4>
                </div>
                  <ol className="breadcrumb fs-7">
                    <li className="breadcrumb-item">
                       <Skeleton width={75} />
                    </li>
                    <li className="breadcrumb-item">
                      <Skeleton width={75} />
                    </li>
                    <li className="breadcrumb-item active"> <Skeleton width={75} /></li>
                  </ol>

              </>
              ):(
                <>
                <div className="mb-0 px-0">
                    <h4 className="text-primary fw-bold">Manage Target</h4>
                </div>
                  <ol className="breadcrumb fs-7">
                    <li className="breadcrumb-item">
                      <Link to="/dashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="fa-solid fa-angles-right fs-8"></i>
                    </li>
                    <li className="breadcrumb-item active">KPI Management</li>
                  </ol>
                </>
            )}
            
        </div>
      </div>

 
      
<div className="row g-3">
  {/* FORM SECTION */}
  <div className="col-lg-5">
    <div className="card shadow-sm border-0">
      <div className="card-body">
        {loading ? (
          <>
            <Skeleton height={35} width={180} className="mb-3" />
            <div className="mb-3">
              <Skeleton height={25} width={120} />
              <Skeleton height={40} className="mt-2" />
            </div>
            <div className="mb-3">
              <Skeleton height={25} width={120} />
              <Skeleton height={40} className="mt-2" />
            </div>
            <div className="mb-3">
              <Skeleton height={25} width={120} />
              <Skeleton height={40} className="mt-2" />
            </div>
            <div className="mb-3">
              <Skeleton height={25} width={120} />
              <Skeleton height={40} className="mt-2" />
            </div>
            <div className="mb-3">
              <Skeleton height={25} width={120} />
              <Skeleton height={40} className="mt-2" />
            </div>
            <div className="d-flex justify-content-end gap-2 mt-4">
              <Skeleton height={40} width={100} />
              <Skeleton height={40} width={120} />
            </div>
          </>
        ) : (
          <>
            <h2 className="mb-3 text-primary fw-bold" style={{ fontSize: "2rem" }}>
              Set Target
            </h2>

            <div className="mb-3">
              <label className="text-black font-w500 fs-7">Branch</label>
              <Select
                placeholder="Select Branch"
                options={branchOptions}
                onChange={handleBranchChange}
                value={branchOptions.find((opt) => opt.value === selectedBranch) || null}
              />
              {showValidation && !selectedBranch && (
                <span className="text-danger fs-7">Branch is required</span>
              )}
            </div>

            <div className="mb-3">
              <label className="text-black font-w500 fs-7">Month</label>
              <DatePicker
                value={monthFilValue}
                onChange={setMonthFilValue}
                format="MMM-YYYY"
                onlyMonthPicker
                calendarPosition="top"
                render={(value, openCalendar) => (
                  <div className="position-relative">
                    <input
                      type="text"
                      className="form-control ps-5"
                      value={value}
                      onClick={openCalendar}
                      placeholder="Select Month"
                    />
                    <i
                      className="fa-solid fa-calendar-days position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"
                      style={{ cursor: "pointer", fontSize: "1.5rem" }}
                      onClick={openCalendar}
                    ></i>
                  </div>
                )}
              />
            </div>

            <div className="mb-3">
              <label className="text-black font-w500 fs-7">Target Amount</label>
              <input
                type="number"
                className="form-control"
                placeholder="Enter Target Amount"
                value={targetAmount}
                onChange={(e) => setTargetAmount(e.target.value.slice(0, 10))}
              />
              {showValidation && !targetAmount && (
                <span className="text-danger fs-7">Target Amount is required</span>
              )}
            </div>

            <div className="mb-3">
              <label className="text-black font-w500 fs-7">Pre Customers</label>
              <input
                type="number"
                className="form-control"
                placeholder="Enter Pre Customers"
                value={preCustomers}
                onChange={(e) => setPreCustomers(e.target.value.slice(0, 5))}
              />
            </div>

            <div className="mb-3">
              <label className="text-black font-w500 fs-7">Post Customers</label>
              <input
                type="number"
                className="form-control"
                placeholder="Enter Post Customers"
                value={postCustomers}
                onChange={(e) => setPostCustomers(e.target.value.slice(0, 5))}
              />
            </div>

            <div className="text-end d-flex justify-content-end gap-2">
              <Button
                variant="secondary"
                onClick={handleClear}
                style={{ fontSize: "1.1rem", fontWeight: "500" }}
              >
                Clear <i className="fas fa-eraser ms-2"></i>
              </Button>

              <Button
                variant="primary"
                onClick={handleAddTarget}
                style={{ fontSize: "1.1rem", fontWeight: "500" }}
              >
                Set Target <i className="fas fa-angle-double-right ms-2"></i>
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  </div>

  {/* TABLE SECTION */}
  <div className="col-lg-7">
    <div className="card shadow-sm border-0">
      <div className="card-body">
        {loading ? (
          <>
            <Skeleton height={35} width={200} className="mb-3" />
            <Skeleton count={6} height={30} className="mb-2" />
          </>
        ) : (
          <>
            <h2 className="mb-3 text-primary fw-bold" style={{ fontSize: "2rem" }}>
              Target List
            </h2>

            <div className="table-responsive" style={{ maxHeight: "400px", overflowY: "auto" }}>
              <table className="table align-middle text-center table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable mb-0">
                <thead className="position-sticky top-0 bg-white">
                  <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                    <th className="min-w-100px text-start">Branch</th>
                    <th className="min-w-100px">Month</th>
                    <th className="min-w-120px text-end">Target</th>
                    <th className="min-w-100px text-end">Pre/Post Customers</th>
                  </tr>
                </thead>
                <tbody className="text-black-600 fw-semibold fs-7">
                  {targetsList.length === 0 ? (
                    <tr>
                      <td className="text-center" colSpan={4}>
                        No Data Available
                      </td>
                    </tr>
                  ) : (
                    targetsList.map((t, i) => (
                      <tr key={i}>
                        <td className="text-start text-black">{t.branch || "-"}</td>
                        <td className="text-start text-black">{t.month || "-"}</td>
                        <td className="text-end text-danger fw-bold">
                          {t.targetAmount != null && t.targetAmount !== ""
                            ? new Intl.NumberFormat("en-IN", {
                                style: "currency",
                                currency: "INR",
                                maximumFractionDigits: 0,
                              }).format(t.targetAmount)
                            : "-"}
                        </td>
                        <td className="text-end text-black">
                          {(t.preCustomers || t.postCustomers)
                            ? `${t.preCustomers || 0}/${t.postCustomers || 0}`
                            : "-"}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  </div>
</div>
    </>
  );
};

export default Manage_Target;
